import React from "react";
import { Radio, Select } from "antd";
import { periodLabel } from "../labels";

const { Option } = Select;

/**
 * Блоки управления (ТЗ п.5.3): оформление одинаковое, тип периода — общий.
 * Блок A «Динамика»: тип + диапазон От/До  → мини-графики.
 * Блок B «Отчётный период»: тип + report   → KPI, карточки (число), диаграмма, таблица.
 */

const TypeSwitch = ({ type, onType, L }) => (
  <Radio.Group
    value={type}
    onChange={(e) => onType(e.target.value)}
    buttonStyle="solid"
    size="small"
    className="hc-toolbar__toggle"
  >
    <Radio.Button value="year">{L.year}</Radio.Button>
    <Radio.Button value="quarter">{L.quarter}</Radio.Button>
  </Radio.Group>
);

const PeriodSelect = ({ value, periods, onChange, lang }) => (
  <Select
    value={value}
    onChange={onChange}
    size="small"
    className="hc-toolbar__select"
    dropdownMatchSelectWidth={false}
  >
    {periods.map((p) => (
      <Option key={p.key} value={p.key}>
        {periodLabel(p, lang)}
      </Option>
    ))}
  </Select>
);

/** Блок A «Динамика» — управляет мини-графиками карточек */
export const DynamicsBar = ({
  type,
  periods,
  from,
  to,
  onType,
  onRange,
  lang,
  L,
}) => {
  const idx = (key) => periods.findIndex((p) => p.key === key);

  // Защита диапазона от инверсии (ТЗ п.5.3): От ≤ До
  const handleFrom = (val) => onRange(val, idx(val) > idx(to) ? val : to);
  const handleTo = (val) => onRange(idx(val) < idx(from) ? val : from, val);

  return (
    <div className="hc-toolbar">
      <span className="hc-toolbar__label">{L.period}</span>
      <TypeSwitch type={type} onType={onType} L={L} />
      <span className="hc-toolbar__divider" />
      <span className="hc-toolbar__label">{L.dynamics}</span>
      <span className="hc-toolbar__label hc-toolbar__label--dim">{L.from}</span>
      <PeriodSelect
        value={from}
        periods={periods}
        onChange={handleFrom}
        lang={lang}
      />
      <span className="hc-toolbar__label hc-toolbar__label--dim">{L.to}</span>
      <PeriodSelect
        value={to}
        periods={periods}
        onChange={handleTo}
        lang={lang}
      />
    </div>
  );
};

/** Блок B «Отчётный период» — управляет KPI, крупными числами, диаграммой, таблицей */
export const ReportBar = ({
  type,
  periods,
  report,
  onType,
  onReport,
  lang,
  L,
}) => (
  <div className="hc-toolbar">
    <span className="hc-toolbar__label">{L.period}</span>
    <TypeSwitch type={type} onType={onType} L={L} />
    <span className="hc-toolbar__divider" />
    <span className="hc-toolbar__label">{L.reportPeriod}</span>
    <PeriodSelect
      value={report}
      periods={periods}
      onChange={onReport}
      lang={lang}
    />
  </div>
);
